import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class BankGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private loginService:LoginService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }
      if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER-ADMIN'])){
        return false;
      }else return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }else if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER-ADMIN'])){
        this.router.navigate(['/dashboard']);
        return false;
      }else return true;
  }

}
